import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Introductionuna() {
  return (
    <section className="introduction_una p-100 text_una">
      <Container>
        <Row>
          <Col
            xs={12}
            md={5}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center resp_order"
          >
            <div className="banner_img">
              <StaticImage
                src="../../../images/case-studies/una/intro_img.webp"
                alt="TekRevol"
                className=""
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={579}
                height={692}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <h2>
              <strong>Introduction UNAClient's Brief</strong> Scoping The Core
              Technicalities & Functionalities
            </h2>
            <p>
              The university was looking to turn their career page into a mobile
              app that granted easy access to job seekers and hiring
              professionals, bringing them together. The platform was designed
              to help the students to connect with organizations for a job. With
              a simple yet intuitive interface, the students would be able to
              skim through numerous job opportunities to find the perfect match
              as per their expertise or preferences. Our client's brief helped
              us in creating a strategic roadmap to commence the designing and
              development of the UNA mobile app.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Introductionuna;
